import { render, staticRenderFns } from "./cardUser.vue?vue&type=template&id=0bf576e0&scoped=true"
import script from "./cardUser.vue?vue&type=script&lang=js"
export * from "./cardUser.vue?vue&type=script&lang=js"
import style0 from "./cardUser.vue?vue&type=style&index=0&id=0bf576e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf576e0",
  null
  
)

export default component.exports